import { Record, List, Map, fromJS } from 'immutable'
import { parseEndUser } from 'app/modules/endUser/models'

// Normalize the enriched conversations by separating out the nested, hydrated
// models into top-level collections for each model
export const parseEnrichedConversations = (conversations) => {
  return conversations.reduce((reduction, conversation) => {
    const { endUser } = conversation
    const { enrichmentData } = endUser

    return reduction
      .update('conversations', conversations =>
        conversations.push(parseConversation(conversation)))
      .update('endUsers', endUsers =>
        endUsers.push(parseEndUser(endUser)))
      .update('enrichedCompanyDataByEndUserId', enrichedCompanyDataByEndUserId =>
        enrichedCompanyDataByEndUserId.set(endUser.id, fromJS(enrichmentData)))
  }, Map({
    conversations: List(),
    endUsers: List(),
    enrichedCompanyDataByEndUserId: Map()
  }))
}

export function parseConversation(data) {
  const {
    tags,
    cc,
    bcc,
    collaborators,
    context,
    user,
    participantIds,
    ...rest
  } = data

  const endUserType = data.endUserType || (user && user.type)

  return Conversation({
    tags: List(tags),
    cc: List(cc),
    bcc: List(bcc),
    collaborators: List(collaborators),
    participantIds: List(participantIds),
    context: fromJS(context),
    user: fromJS(user),
    endUserType,
    ...rest,
  })
}

export function parseRoutingAuditLogEntry({ usersAdded, routingAvailabilityDynamoEntries, ...rest }) {
  return RoutingAuditLogEntry({
    usersAdded: usersAdded,
    userAvailabilityList: routingAvailabilityDynamoEntries,
    ...rest,
  })
}

export const Conversation = Record({
  id: undefined,
  displayId: undefined,
  type: undefined,
  status: undefined,
  orgId: undefined,
  inboxId: undefined,
  endUserId: undefined,
  endUserType: undefined,
  customerId: undefined,
  campaignId: undefined,
  subject: null,
  uuid: undefined,
  slackChannel: "",
  tags: List(),
  cc: List(),
  bcc: List(),
  source: null,
  collaborators: List(),
  preview: undefined,
  agentOnlyPreview: undefined,
  lastMessageAuthorId: undefined,
  lastMessageAuthorType: undefined,
  lastMessageContentType: undefined,
  lastMessageType: undefined,
  lastSentMessageTimestamp: undefined,
  lastReadMessageTimestamp: undefined,
  participantIds: List(),
  imported: false,
  createdAt: 0,
  updatedAt: 0,
  closedAt: 0,
  layerUrl: undefined,
  defaultMessageDeliveryChannel: undefined,
  context: Map(),
  slackAnnTimestamp: undefined,
  slackAnnChannelId: undefined,
  unreadMessageCount: undefined,
  user: Map(),
})

export const Inbox = Record({
  id: undefined,
  orgId: undefined,
  name: undefined,
  address: undefined,
  forwardAddress: undefined,
  status: undefined,
  createdAt: 0,
  totalConversationCount: 0,
  openConversationCount: 0
})

export const RoutingAuditLogEntry = Record({
  orgId: undefined,
  conversationId: undefined,
  routingGroupId: undefined,
  executedAt: undefined,
  routingEntryType: undefined,
  ruleId: undefined,
  matchedTargetingConditions: undefined,
  usersAdded: List(),
  rangeKey: undefined,
  routingRule: undefined,
  errorType: undefined,
  userAvailabilityList: List(),
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/models.js